module.exports = __webpack_public_path__ + "img/algorithm.d084fa14.jpg";